import BaseTableNew from 'components/atoms/base-table/new';
import { ACTIVITY_PER_PAGE } from 'infrastructure/hooks/rpm';
import { scrollToTopAsync } from 'infrastructure/functions';
import { type FC, type Dispatch, type SetStateAction } from 'react';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import { useTranslation } from 'react-i18next';
import SearchIcon from 'components/atoms/icons/search.svg?react';
import classNames from 'classnames';
import { ELASTIC_SEARCH_MAX_ITEMS } from 'constants/count';
import { safeClamp } from 'utils/helpers/safeClamp';

import s from './styles.module.scss';
import { useRpmOverviewTableColumns } from './components/columns';

interface Props {
  loading: boolean;
  page: number;
  setPage: (page: number) => void;
  patients?: any[];
  pageSize?: number;
  setPerPage?: Dispatch<SetStateAction<number>>;
  showSizeChanger?: boolean;
  wrapperId: string;
}

const RpmOverviewTable: FC<Props> = ({
  patients,
  loading,
  page,
  setPage,
  setPerPage,
  pageSize = ACTIVITY_PER_PAGE,
  showSizeChanger,
  wrapperId,
}) => {
  const columns = useRpmOverviewTableColumns();
  const { t } = useTranslation();

  return (
    <>
      <BaseTableNew
        dataCy="overview-dashboard-table"
        loading={loading}
        columns={columns}
        items={patients ?? []}
        bordered
        rowKey="guid"
        pagination={{
          current: page,
          pageSize,
          total: safeClamp(patients?.length, 0, ELASTIC_SEARCH_MAX_ITEMS),
          position: ['bottomCenter'],
          showSizeChanger,
        }}
        onChangePage={(newPage, newPageSize) => {
          scrollToTopAsync(wrapperId, 70).then(() => {
            setPage(newPage);
            if (pageSize !== newPageSize) {
              setPage(1);
              setPerPage?.(newPageSize);
            }
          });
        }}
        emptyText={
          <EmptyTablePlaceholder
            text={t('labels.noReadingsFound')}
            icon={<SearchIcon width={100} height={100} />}
            column
          />
        }
        rowClassName={classNames(s['table-row'])}
        rowHoverable={false}
        changeOddRowColor={false}
        className={s.table}
      />
    </>
  );
};
export default RpmOverviewTable;
